import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const ErrorComponent = ({ message = 'Failed to load', children }) => {
  return (
    <Container fluid className="d-flex align-items-center justify-content-center" style={{ minHeight: "200px" }}>
      <Row>
        <Col className="text-center">
          <h6>{message}</h6>
          {children && <div className="mt-3">{children}</div>}
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorComponent;
